import { makeStyles } from '@material-ui/core/styles';
import { addMenu } from 'UI/constants/dimensions';
import { flexAlignCenterFlexStart } from 'UI/utils/styles';

export const useStyles = makeStyles(theme => ({
  menuPopper: {
    borderRadius: theme.spacing(1),
    zIndex: 1
  },
  menuItem: {
    ...flexAlignCenterFlexStart,
    ...addMenu.menuItem
  },
  menuLabel: {
    marginLeft: theme.spacing(1.5)
  },
  menuIcon: {
    color: theme.palette.grey[600]
  }
}));
